<template>
	<a-drawer
	  class="sider-primary"
	  :class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme ]"
	  placement="left"
	  width="250px"
	  :open="sidebarCollapsed"
	  :closable="false"
	  @close="updateCollapse(false)"
    >
		<template #title>
			<div class="brand">
				<!-- <img src="images/logos/LOGO Netplus - By Intercom NEGRO.png" alt="Netplus by Intercom" > -->
			</div>
		</template>
		<div class="drawer-content">
			<MenuSideBar 
				:typeMenu="typeMenu"
        		:sidebarTheme="sidebarTheme"
        		:collapse="sidebarCollapsed"
        		@toggleSidebar="updateCollapse"
    		/>
		</div>
    </a-drawer>
</template>
<script>
import MenuSideBar from './Menu.vue'
export default ({
	emits:[ 'toggleSidebar' ],
	components: {
		MenuSideBar
	},
	props: {
		sidebarCollapsed: {
			type: Boolean,
			default: false,
			required: true
		},
		sidebarTheme: {
			type: String,
			default: 'light'
		},
		sidebarColor: {
			type: String
		},
		typeMenu: {
			type: String,
			default: 'client'
		}
	},
	data() {
		return {
			drawerStatus: "close"
		}
	},
	mounted() {
		// setInterval( () => {
		// 	if (this.collapsed == "true") {
		// 		this.drawerStatus = true
		// 	} else {
		// 		this.drawerStatus = false
		// 	}
		// }, 1000)
	},
	methods: {
		updateCollapse(show) {
    		this.$emit('toggleSidebar', show)
		}
	}

})
</script>
